import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d4a6060"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }

import { useI18n } from 'vue-i18n';

interface Props {
  inline?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseLoader',
  props: {
    inline: { type: Boolean, default: false }
  },
  setup(__props: any) {

const { t } = useI18n();



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["spinner", { spinner__inline: _ctx.inline }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["spinner__circle", { spinner__circle_inline: _ctx.inline }])
    }, null, 2),
    (!_ctx.inline)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(t)("loader")), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})